import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { APP_ENV } from '../conf/app_env';

@Injectable({
	providedIn: 'root'
})
export class MenuService {

	manualChangeMenu$ = new BehaviorSubject<string>(null);

	private dynamicMenus = {
		'home': [
			{ 'name': 'Home', 'secure_module': 0, 'link': ['/home'] },
			// { 'name': 'Pipeline', 'secure_module': 1, 'link': ['/pipeline'], 'hiddenOnEnv': [APP_ENV.Domestic] },
			{ 'name': 'Timeline', 'secure_module': 50, 'link': ['/timeline'], 'hiddenOnEnv': [APP_ENV.Domestic] },
			{ 'name': 'Projects', 'secure_module': 2, 'link': ['/projects'] },
			{ 'name': 'Finance', 'secure_module': 28, 'link': ['/finance'] },
			{ 'name': 'Admin', 'secure_module': 15, 'link': ['/admin'] },
			// { 'name': 'Position matrix', 'secure_module': 58, 'link': ['/charge-matrix'] },
		],
		'projects': [
			{ 'name': '<', 'isBackButton': true, 'link': ['/projects'] },
			// { 'name': 'Timeline', 'secure_module': 55, 'link': ['/projects', ':id', 'timeline'] },
			{ 'name': 'Home', 'secure_module': 3, 'link': ['/projects', ':id'] },
			{
				'name': 'Production plan', 'secure_module': [60,26,4,5], 'link': ['/projects', ':id', 'productionplan'] ,
				'subMenu': [
					{ 'name': 'Timeline', 'secure_module': 60, 'link': ['/projects', ':id', 'productionplan','timeline'] },
					{ 'name': 'Calendar', 'secure_module': 26, 'link': ['/projects', ':id', 'productionplan','calendar'] },
					{ 'name': 'Parameters', 'secure_module': 4, 'link': ['/projects', ':id', 'productionplan', 'parameters'] },
					{ 'name': 'Production plan', 'secure_module': 5, 'link': ['/projects', ':id', 'productionplan', 'production-plan'] }
				]
			},
			{ 
				'name': 'Breakdown', 
				'secure_module': [6,7],
				'link': ['/projects', ':id', 'breakdown'],
				'subMenu': [
					{ 'name': 'Chapters', 'secure_module': 6, 'link': ['/projects', ':id', 'breakdown','chapters'] },
					{ 'name': 'Scenes', 'secure_module': 7, 'link': ['/projects', ':id', 'breakdown', 'scenes'] },
				],
				'showSubMenu': false
			},
			{ 
				'name': 'Elements', 'secure_module': [10,11,13,54,53,52,36], 'link': ['/projects', ':id', 'elements'],
				'subMenu': [
					{ 'name': 'Characters', 'secure_module': 10, 'link': ['/projects', ':id', 'elements','characters'] },
					{ 'name': 'Locations', 'secure_module': 11, 'link': ['/projects', ':id', 'elements','locations'] },
					{ 'name': 'Elements', 'secure_module': 13, 'link': ['/projects', ':id', 'elements','elements'] },
					{ 'name': 'Events', 'secure_module': 54, 'link': ['/projects', ':id', 'elements', 'events'], 'hiddenOnEnv': [APP_ENV.Domestic] },
					{ 'name': 'Songs', 'secure_module': 53, 'link': ['/projects', ':id', 'elements', 'songs'], 'hiddenOnEnv': [APP_ENV.Domestic] },
					{ 'name': 'Interfaces', 'secure_module': 52, 'link': ['/projects', ':id', 'elements', 'interfaces'], 'hiddenOnEnv': [APP_ENV.Domestic] },
					{ 'name': 'Brands', 'secure_module': 36, 'link': ['/projects', ':id', 'elements', 'brands'] }, 
				// { 'name': 'Sets', 'secure_module': 12, 'link': ['/projects', ':id', 'elements','sets'] }
				],
				'showSubMenu': false
			},
	  		{ 'name': 'Production', 'secure_module': [51,27,14,57], 'link': ['/projects', ':id', 'production'],
				'subMenu': [
					{ 'name': 'Stripboard', 'secure_module': 51, 'link': ['/projects', ':id', 'production','stripboard'] },
					{ 'name': 'Units', 'secure_module': 27, 'link': ['/projects', ':id', 'production','units'] },
					{ 'name': 'Shootings', 'secure_module': 14, 'link': ['/projects', ':id', 'production', 'shooting-schedules'] },
					{ 'name': 'Requirements', 'secure_module': 57, 'link': ['/projects', ':id', 'production','requirements'] }
				],
				'showSubMenu': false
			},
			// { 'name': 'Parameters', 'secure_module': 4, 'link': ['/projects', ':id', 'parameters'] },
			// { 'name': 'Calendar', 'secure_module': 26, 'link': ['/projects', ':id', 'calendar'] },
			// { 'name': 'Production plan', 'secure_module': 5, 'link': ['/projects', ':id', 'production-plan'] },
			// { 'name': 'Chapters', 'secure_module': 6, 'link': ['/projects', ':id', 'chapters'] },
			// { 'name': 'Scenes', 'secure_module': 7, 'link': ['/projects', ':id', 'scenes'] },
			// { 'name': 'Roles', 'secure_module': 59, 'link': ['/projects', ':id', 'roles'] },
			// { 'name': 'Characters', 'secure_module': 10, 'link': ['/projects', ':id', 'characters'] },
			// { 'name': 'Locations', 'secure_module': 11, 'link': ['/projects', ':id', 'locations'] },
			// { 'name': 'Sets', 'secure_module': 12, 'link': ['/projects', ':id', 'sets'] },
			// { 'name': 'Category elements', 'secure_module': 13, 'link': ['/projects', ':id', 'categories'] },
			// { 'name': 'Elements', 'secure_module': 13, 'link': ['/projects', ':id', 'elements'] },
			// { 'name': 'Stripboard', 'secure_module': 51, 'link': ['/projects', ':id', 'stripboard'] },
			// { 'name': 'Songs', 'secure_module': 53, 'link': ['/projects', ':id', 'songs'], 'hiddenOnEnv': [APP_ENV.Domestic] },
			// { 'name': 'Interfaces', 'secure_module': 52, 'link': ['/projects', ':id', 'interfaces'], 'hiddenOnEnv': [APP_ENV.Domestic] },
			// { 'name': 'Brands', 'secure_module': 36, 'link': ['/projects', ':id', 'brands'] },
			// { 'name': 'Events', 'secure_module': 54, 'link': ['/projects', ':id', 'events'], 'hiddenOnEnv': [APP_ENV.Domestic] },
			// { 'name': 'Shooting schedule', 'secure_module': 14, 'link': ['/projects', ':id', 'shooting-schedules'] },
			// { 'name': 'Units', 'secure_module': 27, 'link': ['/projects', ':id', 'units'] },
			// { 'name': 'Requirements', 'secure_module': 57, 'link': ['/projects', ':id', 'requirements'] },
			{ 'name': 'Continuity', 'secure_module': [22,61,62], 'link': ['/projects', ':id', 'continuity'],
				'subMenu': [
					{ 'name': 'Continuity characters', 'secure_module': 61, 'link': ['/projects', ':id', 'continuity', 'characters'] },
					{ 'name': 'Continuity days', 'secure_module': 61, 'link': ['/projects', ':id', 'continuity', 'days'] },
					{ 'name': 'Continuity sets', 'secure_module': 62, 'link': ['/projects', ':id', 'continuity', 'location-sets'] },
					{ 'name': 'All images sets', 'secure_module': 62, 'link': ['/projects', ':id', 'continuity', 'sets'] },
					{ 'name': 'All images characters', 'secure_module': 61, 'link': ['/projects', ':id', 'continuity','all'] },
				],
				'showSubMenu': false
			},
			{ 'name': 'Post production', 'secure_module': [60,39,38,49], 'link': ['/projects', ':id', 'post'],
        		'subMenu': [
					{ 'name': 'Timeline', 'secure_module': 60, 'link': ['/projects', ':id', 'post', 'timeline'] },
					{ 'name': 'Episodes', 'secure_module': 39, 'link': ['/projects', ':id', 'post', 'episodes'] },
					{ 'name': 'Clips', 'secure_module': 38, 'link': ['/projects', ':id', 'post', 'clips'] },
					{ 'name': 'Assets', 'secure_module': 49, 'link': ['/projects', ':id', 'post', 'assets'] },
				],
				'showSubMenu': false
			},
			{ 'name': 'Finance', 'secure_module': [29,30,32,31,34], 'link': ['/projects', ':id', 'finance'],
        		'subMenu': [
					{ 'name': 'Budget', 'secure_module': 63, 'link': ['/projects', ':id', 'finance','budget'], 'justInProject': true },
					{ 'name': 'Catering', 'secure_module': 34, 'link': ['/projects', ':id', 'finance','caterings'] },
					{ 'name': 'Services', 'secure_module': 34, 'link': ['/projects', ':id', 'finance','services'] },
					{ 'name': 'Cash advance', 'secure_module': 31, 'link': ['/projects', ':id', 'finance','cash-advance'] },
					{ 'name': 'Vendors', 'secure_module': 32, 'link': ['/projects', ':id', 'finance','vendors'] }
				],
				'showSubmenu': false,
},
		]
	}

	getDataFromRoute(property): string | null {
		let child = this.route.firstChild;
		while (child) {
			if (child.firstChild) {
				child = child.firstChild;
			} else if (child.snapshot.data && child.snapshot.data[property]) {
				return child.snapshot.data[property];
			} else {
				return null;
			}
		}
		return null;
	}

	/**
	 * Función que obtiene params de activatedRoute desde un servicio.
	 * @param route 
	 */
	getParams(route: ActivatedRoute): Params {
		let params = route.snapshot.params
		params = { ...route.snapshot.queryParams, ...params }
		if (route.children) {
			for (let r of route.children) {
				params = { ...this.getParams(r), ...params };
			}
		}
		return params;
	}

  getMenu(menuName) {
    if (menuName) {
      let params = this.getParams(this.route);
      let menuCopy = JSON.parse(JSON.stringify(this.dynamicMenus[menuName]));
  
      // Agrega parámetros de ruta al menú principal
      for (const itemMenu of menuCopy) {
        itemMenu.link = itemMenu.link.map(x => {
          if (x.startsWith(':')) {
            x = params[x.substring(1)];
          }
          return x;
        });
  
        // Agrega parámetros de ruta a los submenús
        if (itemMenu.subMenu) {
          for (const subMenuItem of itemMenu.subMenu) {
            subMenuItem.link = subMenuItem.link.map(x => {
              if (x.startsWith(':')) {
                x = params[x.substring(1)];
              }
              return x;
            });
          }
        }
      }
      return menuCopy;
    }
  }

	constructor(private route: ActivatedRoute) { }
}
